import React, { useContext } from 'react';
import { Link } from 'react-scroll';
import { motion } from 'framer-motion';

import { themeContext } from '../../Context';

import Vector1 from '../../img/Vector1.png';
import Vector2 from '../../img/Vector2.png';
import boy from '../../img/boy.png';
import glassesEmoji from '../../img/glassesEmoji.png';
import thumbsUp from '../../img/thumbsUp.png';
import crown from '../../img/crown.png';
import FloatingDiv from '../FloatingDiv/FloatingDiv';
import Github from '../../img/github.png';
import LinkedIn from '../../img/linkedin.png';
import Instagram from '../../img/instagram.png';

import './Intro.css';

const Intro = () => {
  // Transition
  const transition = { duration: 2, type: 'string' };

  // context
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <div className="Intro" id="Intro">
      {/* left name side */}
      <div className="i-left">
        <div className="i-name">
          <span style={{ color: darkMode ? 'white' : '' }}>Hy! I Am</span>
          <span>Rahul deep</span>
          <span>
            Experienced Front-End Developer Showcasing Creative Web Solutions
            with high level of experience in web designing and development,
            maintaining the Quality of work.
          </span>
        </div>
        <Link to="contact" smooth={true} spy={true}>
          <button className="button i-button">Hire me</button>
        </Link>
        {/* social icons */}
        <div className="i-icons">
          <a
            href="https://github.com/deeprahul339"
            rel="noreferrer"
            target="_blank"
          >
            <img src={Github} alt="github" />
          </a>
          <a
            href="https://www.linkedin.com/in/rahul-deep-2a9354145/"
            rel="noreferrer"
            target="_blank"
          >
            <img src={LinkedIn} alt="linkedIn" />
          </a>
          <a
            href="https://www.instagram.com/deeprahul339/"
            rel="noreferrer"
            target="_blank"
          >
            <img src={Instagram} alt="instagram" />
          </a>
        </div>
      </div>
      {/* right image side */}
      <div className="i-right">
        <img src={Vector1} alt="" />
        <img src={Vector2} alt="" />
        <img src={boy} alt="" />
        {/* animation */}
        <motion.img
          initial={{ left: '-36%' }}
          whileInView={{ left: '-24%' }}
          transition={transition}
          src={glassesEmoji}
          alt=""
        />

        <motion.div
          initial={{ top: '-4%', left: '74%' }}
          whileInView={{ left: '68%' }}
          transition={transition}
          className="floating-div"
        >
          <FloatingDiv img={crown} text1="Web" text2="Developer" />
        </motion.div>

        {/* animation */}
        <motion.div
          initial={{ left: '9rem', top: '18rem' }}
          whileInView={{ left: '0rem' }}
          transition={transition}
          className="floating-div"
        >
          <FloatingDiv img={thumbsUp} text1="Best Design" text2="Award" />
        </motion.div>
        {/*  will uncomment later if required*/}
        {/* <div className="blur" style={{ background: "rgb(238 210 255)" }}></div> */}
        {/* <div
          className="blur"
          style={{
            background: "#C1F5FF",
            top: "17rem",
            width: "21rem",
            height: "11rem",
            left: "-9rem",
          }}
        ></div> */}
      </div>
    </div>
  );
};

export default Intro;
